import { highlightTree } from "@lezer/highlight";
import { LanguageDescription } from "@codemirror/language";
import { languages } from "@codemirror/language-data";
import { additionalLanguages } from "@/editor_languages";
import { escapeHtml } from "@/utilities";
import { rougeStyle } from "@/rouge_style";

// Judges may emit Rouge-specific names that have no CodeMirror alias.
const ROUGE_ALIASES: Record<string, string> = {
    python3: "python",
    console: "shell",
};

export async function highlightCode(code: string, lexer: string): Promise<string> {
    const name = ROUGE_ALIASES[lexer.toLowerCase()] ?? lexer;
    const desc = LanguageDescription.matchLanguageName(additionalLanguages.concat(languages), name, false);
    if (!desc) return escapeHtml(code);

    let lang;
    try {
        lang = await desc.load();
    } catch {
        return escapeHtml(code);
    }
    const tree = lang.language.parser.parse(code);

    let result = "";
    let pos = 0;
    highlightTree(tree, rougeStyle, (from, to, cls) => {
        if (from > pos) result += escapeHtml(code.slice(pos, from));
        result += `<span class="${cls}">${escapeHtml(code.slice(from, to))}</span>`;
        pos = to;
    });
    if (pos < code.length) result += escapeHtml(code.slice(pos));
    return result;
}
